/* eslint-disable no-empty */ /* eslint-disable func-names */ if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s);
        var i = matches.length;
        while(--i >= 0 && matches.item(i) !== this){}
        return i > -1;
    };
}
export { };
